import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { AlicuotaIvaService, MaterialesService, FormaDePagoService, MenuFuncionService, MonedaService, PedidoService, ProveedorService, TenantService } from '../../../../../src/app/shared/services';

import { MaterialDto, PedidoItemDto, MenuFuncionCodes, FormaDePago, SearchFormaDePagoRequest, Proveedor, SearchProveedorRequest, PedidoPresupuesto, SearchMaterialRequest, SavePedidoPresupuestoSeleccion, DialogConfirmResponse, DialogConfirmRequest, PedidoPresupuestoFormaPago, SearchAlicuotaIvaRequest, AlicuotaIva, TenantFeatureFlags, LocalStorageKeys,
  SearchMonedaRequest, Moneda, SavePedidoPresupuesto, TipoCompra, PedidoPresupuestoDetalle, DialogAgregarPresupuesto
 } from '../../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-dialog-agregar-presupuesto',
  templateUrl: './dialog-agregar-presupuesto.component.html',
  styleUrls: ['./dialog-agregar-presupuesto.component.scss']
})

export class DialogAgregarPresupuestoComponent implements OnInit {

  @ViewChild('detalleGrid')
  public detalleGrid: GridComponent;

  public title: string;
  public message: string;
  public buttonAcceptText: string;
  public buttonCancelText: string;
  isSearching: boolean = false;
  isMaterialSearching: boolean = false;
  isDetalleSearching: boolean = false;
  isProveedorSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isTipoCompraSearching: boolean = false;
  isFormaPagoSearching: boolean = false;
  isPedidoItemsSearching: boolean = false;
  isPresupuestoDetalleSearching: boolean = false;
  isDeleting: boolean = false;
  isSaving: boolean = false;
  isSavingSeleccion: boolean = false;
  isValidating: boolean = false;

  esPrecargaPresupuestoDetalle: boolean = false;
  canSelect: boolean = false;
  canEdit: boolean = false;

  formGroup: FormGroup;

  pedidoItem: PedidoItemDto;
  proveedorList: Proveedor[] = [];
  filteredProveedorList: Proveedor[] = [];
  itemPresupuesto: PedidoPresupuesto;
  proveedor: Proveedor;
  pedidoItemList: PedidoItemDto[];
  preselectedPedidoItem: PedidoItemDto;

  formaPagoList:FormaDePago[]=[];
  tipoCompraList:TipoCompra[] = [];
  monedaList: Moneda[] = [];
  filteredMaterialList: MaterialDto[] = [];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  msgError: string = "";

  presupuestoAdjuntoBase64: string | ArrayBuffer | null;
  presupuestoAdjuntoExtension: string = "";
  comprobanteFile: any;
  selectedFile: any;
  alicuotaIvaList: AlicuotaIva[];
  isAlicuotaIvaSearching: boolean = false;
  tenantFeatureFlags: TenantFeatureFlags;

  constructor(
    private dialogRef: MatDialogRef<DialogAgregarPresupuesto>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAgregarPresupuesto,
    private menuService: MenuFuncionService,
    private pedidoService: PedidoService,
    private route: ActivatedRoute,
    private monedaService: MonedaService,
    private proveedorService: ProveedorService,
    private formaPagoService: FormaDePagoService,
    private materialService: MaterialesService,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private alicuotaIvaService: AlicuotaIvaService,
    private tenantService: TenantService,
  ) { }

  ngOnInit() {
    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_PRESUPUESTO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });

    this.buttonAcceptText = 'Guardar';
    this.buttonCancelText = (this.data.CanEditPresupuesto ? 'Cancelar' : 'Cerrar');
  }

  loadView() {
    this.canEdit = this.data?.CanEditPresupuesto ?? false;
    this.canSelect = this.data?.CanSelectPresupuesto ?? false;
    this.pedidoItemList = this.data?.PedidoItems;

    if(this.data?.PrecargaPedidoItemId != null && this.data?.PrecargaPedidoItemId >= 0) {
      if(this.data?.PrecargaPedidoItemId > 0) {
        this.preselectedPedidoItem = this.pedidoItemList.find(pedidoItem => pedidoItem.Id == this.data?.PrecargaPedidoItemId);
      }
      //Puede seleccionar materiales para el presupuesto si no viene preseleccionado de la vista de pedidos
      this.esPrecargaPresupuestoDetalle = true;
    }

    this.buildForm();

    this.loadEntity();

    this.getProveedoresAutocomplete();
    this.getTipoCompra();
    this.getMoneda();
    this.getFormaDePago();
    this.getAlicuotaIva();
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null,null,null,null,null,null,null,null,true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadEntity() {
    if (this.data.PresupuestoId != null && this.data.PresupuestoId > 0) {
      this.isSearching = true;
      this.pedidoService.getPresupuesto(this.data.PedidoId, this.data.PresupuestoId).subscribe(data => {
        this.isSearching = false;
        if (data != null && data.Success) {
          this.itemPresupuesto = data.Result;

          if (this.itemPresupuesto != null && this.itemPresupuesto.Id > 0) {
            this.filteredProveedorList = [new Proveedor
              (
                (this.itemPresupuesto.ProveedorId !== null ? this.itemPresupuesto.ProveedorId : 0), null,
                this.itemPresupuesto.ProveedorNombre,
                null,null,null,null,null,null,null,null,null,null,null,null,null,null,[]
              )];

            this.formGroup.patchValue({
              ...this.itemPresupuesto,
              Proveedor: this.filteredProveedorList[0],
              FormaPagoId: this.itemPresupuesto.FormasPago?.map(s => s.FormaPagoId)
            });

            this.getPresupuestoDetalles(this.itemPresupuesto.PedidoId, this.itemPresupuesto.Id);
          }
          else
            this.msgError = "No se encontró el presupuesto seleccionado.";
        }
        else
          this.msgError = "Ocurrió un error al intentar obtener los datos del presupuesto.";
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
    else
    {
      this.itemPresupuesto = new PedidoPresupuesto(0, null, this.data?.PedidoId, 0, null, null, 0, null, null, null, null, null, null, null, true, null, null, false, [], []);
      this.formGroup.patchValue(this.itemPresupuesto);
      this.canSelect = false;

      if (this.esPrecargaPresupuestoDetalle) {
        if ((this.data.PrecargaPedidoItemId > 0) && (this.preselectedPedidoItem == null || this.data.PrecargaPedidoItemId <= 0)) {
          this.sharedFunctions.showMessage("No se encontró un material del pedido preseleccionado", "Error");
          return false;
        }

        if (this.itemPresupuesto.PresupuestoDetalle == null)
          this.itemPresupuesto.PresupuestoDetalle = [];

        if(this.data.PrecargaPedidoItemId > 0) {
          this.itemPresupuesto.PresupuestoDetalle.push(new PedidoPresupuestoDetalle(0, this.itemPresupuesto.Id,
            this.preselectedPedidoItem.Id, this.preselectedPedidoItem.MaterialNombre, this.preselectedPedidoItem.MonedaId,
            this.preselectedPedidoItem.MonedaNombre, (this.itemPresupuesto.Monto / this.preselectedPedidoItem.Cantidad),
            this.preselectedPedidoItem.Cantidad, this.preselectedPedidoItem.Detalle, this.itemPresupuesto.Monto,
            false, null, null, true, null, false));
        } else {
          this.pedidoItemList.map(pedidoItem =>  (
            this.itemPresupuesto.PresupuestoDetalle.push(new PedidoPresupuestoDetalle(0, this.itemPresupuesto.Id,
            pedidoItem.Id,pedidoItem.MaterialNombre,pedidoItem.MonedaId,
            pedidoItem.MonedaNombre, (this.itemPresupuesto.Monto /pedidoItem.Cantidad),
            pedidoItem.Cantidad,pedidoItem.Detalle, this.itemPresupuesto.Monto,
            false, null, null, true, null, false))));
        }
      }
      else
        this.getPresupuestoDetalles(this.data.PedidoId, 0);
    };
  }

  getPresupuestoDetalles(pedidoId: number, id: number) {
    this.isPresupuestoDetalleSearching = true;
    this.pedidoService.getPresupuestoDetalles(pedidoId, id).subscribe(data => {
      this.isPresupuestoDetalleSearching = false;
      if (this.itemPresupuesto != null) {
        this.itemPresupuesto.PresupuestoDetalle = data?.Result;

        if (this.itemPresupuesto.PresupuestoDetalle != null) {
          for (var i=0; i<this.itemPresupuesto.PresupuestoDetalle.length; i++) {
            this.itemPresupuesto.PresupuestoDetalle[i].MaterialFormGroup = this.formBuilder.group({
              'Material': [null]
            });

            this.getMaterialesAutocomplete(i);
            this.itemPresupuesto.PresupuestoDetalle[i].MaterialFormGroup?.patchValue({
              Material: new MaterialDto(this.itemPresupuesto.PresupuestoDetalle[i].MaterialId,this.itemPresupuesto.PresupuestoDetalle[i].MaterialNombre,null,null,null,null,null,true)
            });
          }
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.isPresupuestoDetalleSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  displayMaterial(material: MaterialDto): string {
    return material && material?.Nombre ? material.Nombre : '';
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, Validators.maxLength(100)],
      'Proveedor': [null, [Validators.required, Validators.maxLength(150)]],
      'FormaPagoId': [null, Validators.required],
      'MonedaId': [null, Validators.required],
      'Monto': [null, Validators.required],
      'TipoCompra': [null, Validators.required],
      'FechaVigencia': [new Date()],
      'Observacion': [null],
      'AlicuotaIvaId': [null]
    });

    if (this.tenantFeatureFlags?.HabilitarControlCaja) {
      const alicuotaIvaControl = this.formGroup.get('AlicuotaIvaId');

      alicuotaIvaControl?.setValidators([Validators.required]);
      alicuotaIvaControl?.updateValueAndValidity();
    }
  }

  getTipoCompra() {
    this.isTipoCompraSearching = true;
    this.pedidoService.getAllTipoCompra().subscribe(data=> {
      this.isTipoCompraSearching = false;
      this.tipoCompraList = data?.Result;
    },
    (err: HttpErrorResponse)=> {
      this.isTipoCompraSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMoneda() {
    this.isMonedaSearching = true;
    this.monedaService.search(new SearchMonedaRequest(null,null,true,"Codigo",null,null,null,true)).subscribe(data=> {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse)=> {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getFormaDePago() {
    this.isFormaPagoSearching = true;
    this.formaPagoService.search(new SearchFormaDePagoRequest(null,null,null,null,null,null,true)).subscribe(data=> {
      this.isFormaPagoSearching = false;
      this.formaPagoList = data?.result;
    },
    (err: HttpErrorResponse)=> {
      this.isFormaPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    this.formGroup.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  getMaterialesAutocomplete(index: number) {
    this.itemPresupuesto.PresupuestoDetalle[index].MaterialFormGroup?.get('Material')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredMaterialList = [];
          this.itemPresupuesto.PresupuestoDetalle[index].IsMaterialAutoSearching = true;
        }),
        switchMap(value => this.materialService.search(new SearchMaterialRequest(null, null, null, null, value, null,this.data.PedidoTipoMaterialId, true))
          .pipe(
            finalize(() => {
              this.itemPresupuesto.PresupuestoDetalle[index].IsMaterialAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredMaterialList = data.result;
        else
          this.filteredMaterialList = [];
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  onGuardarPresupuesto() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.itemPresupuesto?.PresupuestoDetalle == null || this.itemPresupuesto?.PresupuestoDetalle.length == 0) {
      this.sharedFunctions.showMessage("Debe ingresar al menos un detalle para el presupuesto", "Error");
      return false;
    }
    if (this.itemPresupuesto?.PresupuestoDetalle.length > 150) {
      this.sharedFunctions.showMessage("El detalle no debe superar los 150 caracteres", "Error");
      return false;
    }

    var index = this.presupuestoAdjuntoBase64?.toString()?.indexOf(",");
    var r = new SavePedidoPresupuesto(null,null,null,null,null,null,null,null,null,null,null,false,true,null,null);
    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.itemPresupuesto?.Id ?? 0),
        FormasPago: this.formGroup.get("FormaPagoId")?.value?.map(s => new PedidoPresupuestoFormaPago(0, (this.itemPresupuesto?.Id ?? 0), s, "")),
        IncluyeFlete: (this.itemPresupuesto?.IncluyeFlete ?? false),
        ProveedorId: this.formGroup.get("Proveedor")?.value?.Id,
        PedidoId: this.data.PedidoId,
        PresupuestoUrl: this.itemPresupuesto.PresupuestoUrl,
        PresupuestoBase64: (index != null && index >= 0 ? this.presupuestoAdjuntoBase64?.toString()?.substring(index + 1) : null),
        PresupuestoExtension: this.presupuestoAdjuntoExtension,
        Activo: (this.itemPresupuesto?.Activo ?? true),
        PresupuestoDetalle: this.itemPresupuesto?.PresupuestoDetalle.map(s => new PedidoPresupuestoDetalle(s.Id, s.PedidoPresupuestoId,
            s.PedidoItemId, s.PedidoItemMaterial, this.formGroup.get("MonedaId")?.value, s.MonedaNombre, s.MontoUnitario, s.Cantidad,
            s.Detalle, s.Total, s.EsVariante, s.MaterialId, s.MaterialNombre, s.Seleccionado, null, false))
      }
    };

    this.isSaving = true;

    if (this.esPrecargaPresupuestoDetalle) {
      this.pedidoService.savePresupuestoPrecargado(r).subscribe(data => {
        this.isSaving = false;
        if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
          this.dialogRef.close(data.Result);
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isSaving = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
    else {
      this.pedidoService.savePresupuesto(r).subscribe(data => {
        this.isSaving = false;
        if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
          //this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
          this.dialogRef.close(data.Result);
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isSaving = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
  }

  onGuardarSeleccion() {
    if (this.itemPresupuesto?.PresupuestoDetalle == null || this.itemPresupuesto?.PresupuestoDetalle.length == 0) {
      this.sharedFunctions.showMessage("No hay detalles de presupuestos disponibles en este pedido", "Error");
      return false;
    }

    if (!this.itemPresupuesto?.PresupuestoDetalle?.some(f => f.Seleccionado == true)) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        width: '600px',
        data: new DialogConfirmRequest(
          "Selección de Presupuesto",
          "No tiene seleccionado ningún detalle de presupuesto. ¿Está seguro que desea continuar con la operación?",
          null, null
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.doSavePresupuestoSeleccion();
        }
      });
    }
    else
      this.doSavePresupuestoSeleccion();
  }

  doSavePresupuestoSeleccion() {
    var r = new SavePedidoPresupuestoSeleccion
    (
      this.itemPresupuesto.PedidoId,
      this.itemPresupuesto.ProveedorId,
      this.itemPresupuesto?.PresupuestoDetalle?.filter(f => f.Seleccionado == true)?.map(s => s.Id)
    );

    // console.log(r);
    this.isSavingSeleccion = true;
    this.pedidoService.savePresupuestoSeleccion(r).subscribe(data => {
      this.isSavingSeleccion = false;
      if (data != null && data.Success) {
        //this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.dialogRef.close(this.itemPresupuesto);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingSeleccion = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  selectFile(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.comprobanteFile = event.target.files;
    }
    let files = [].slice.call(event.target.files);
    this.selectedFile = files.map(f => f.name).join(', ');
    this.convertFileToBase64(event);
  }

  convertFileToBase64(event) {
    this.presupuestoAdjuntoBase64 = null;
    const file = event.target.files[0];
    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.presupuestoAdjuntoBase64 = reader.result;
      };
      reader.onloadend = () => {
        this.presupuestoAdjuntoBase64 = reader.result;
        this.presupuestoAdjuntoExtension = (file?.name?.split('.')?.pop() ?? "");
      };
    }
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onMontoChange() {
    if (!this.esPrecargaPresupuestoDetalle)
      return false;

    if (this.itemPresupuesto?.PresupuestoDetalle != null) {
      for (var i=0; i<this.itemPresupuesto.PresupuestoDetalle.length; i++) {
        const montoTotal = (this.formGroup.get("Monto")?.value ?? 0) / this.itemPresupuesto.PresupuestoDetalle.length;
        this.itemPresupuesto.PresupuestoDetalle[i].Total = montoTotal;
        this.itemPresupuesto.PresupuestoDetalle[i].MontoUnitario = this.itemPresupuesto.PresupuestoDetalle[i].Total / this.itemPresupuesto.PresupuestoDetalle[i].Cantidad;
      }

      this.detalleGrid.refresh();
    }
  }

  deleteFile() {
    this.itemPresupuesto.PresupuestoUrl = null;
    this.presupuestoAdjuntoBase64 = null;
    this.presupuestoAdjuntoExtension = '';
  }

  onDetallePresupuestoChange(rowIndex: number, pedidoItemId: number, event: any) {

    if (rowIndex >= 0 && this.itemPresupuesto?.PresupuestoDetalle != null) {

      var pedidoItemIndex = this.pedidoItemList.map(s => s.Id).indexOf(pedidoItemId);
      var controlName = event.target?.name ?? event.source?.ngControl?.name ?? event.source?.name ?? event.source?.id;
      var controlValue = event.target?.value ?? event.value ?? event.checked ?? event.option?.value;

      if (controlName != null && controlName.includes("mat-autocomplete"))
        controlName = "mat-autocomplete";
      switch (controlName) {
        case "EsVariante":
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].EsVariante = controlValue;
          break;
        case "PedidoItemId":
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].PedidoItemId = Number(controlValue);

          if (pedidoItemIndex >= 0) {
            this.itemPresupuesto.PresupuestoDetalle[rowIndex].Detalle = this.pedidoItemList[pedidoItemIndex].Detalle;
            this.itemPresupuesto.PresupuestoDetalle[rowIndex].Cantidad = this.pedidoItemList[pedidoItemIndex].Cantidad;
          }
          break;
        case "MaterialId":
        case "mat-autocomplete": //Tiene este ID el autocomplete de Materiales
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].MaterialId = this.itemPresupuesto.PresupuestoDetalle[rowIndex].MaterialFormGroup?.get("Material")?.value?.Id;
          break;
        case "Detalle":
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].Detalle = controlValue;
          break;
        case "MontoUnitario":
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].MontoUnitario = Number(controlValue);
          break;
        case "Cantidad":
          this.itemPresupuesto.PresupuestoDetalle[rowIndex].Cantidad = Number(controlValue);
          break;
      }
      this.itemPresupuesto.PresupuestoDetalle[rowIndex].Total = Number((this.itemPresupuesto.PresupuestoDetalle[rowIndex].MontoUnitario ?? 0) * (this.itemPresupuesto.PresupuestoDetalle[rowIndex].Cantidad ?? 0));
      this.detalleGrid.refresh();
    }
  }

  calculateMontoTotal() {
    if (this.itemPresupuesto?.PresupuestoDetalle != null)
      return this.itemPresupuesto.PresupuestoDetalle.reduce((sum, current) => sum + current.Total, 0);
    return 0;
  }

  onNuevoDetalle() {
    if (this.itemPresupuesto == null)
      return;

    if (this.itemPresupuesto?.PresupuestoDetalle == null)
      this.itemPresupuesto.PresupuestoDetalle = [];

    var i = this.itemPresupuesto.PresupuestoDetalle.push(new PedidoPresupuestoDetalle(0, this.itemPresupuesto.Id, 0, null, this.itemPresupuesto.MonedaId, null, 0, 0, null, 0, false, null, null, false, null, false));
    i--;
    this.itemPresupuesto.PresupuestoDetalle[i].MaterialFormGroup = this.formBuilder.group({
      'Material': [null]
    });

    this.getMaterialesAutocomplete(i);
    this.itemPresupuesto.PresupuestoDetalle[i].MaterialFormGroup?.patchValue({
      Material: new MaterialDto(0, null, null, null, null, null, null, true)
    });

    this.detalleGrid.refresh();
  }

  deletePresupuestoDetalle(p: any) {
    // console.log(p?.index ?? -1);
    if (p != null) {
      if (this.itemPresupuesto?.PresupuestoDetalle == null || this.itemPresupuesto?.PresupuestoDetalle.length == 0)
        return;

      if (p.index >= 0) {
        this.itemPresupuesto.PresupuestoDetalle[p.index].MaterialFormGroup?.reset();
        this.itemPresupuesto.PresupuestoDetalle[p.index].MaterialFormGroup = null;
        // console.log(this.itemPresupuesto.PresupuestoDetalle[p.index]);
        this.itemPresupuesto.PresupuestoDetalle.splice(p.index, 1);
        this.detalleGrid.refresh();
      }
    }
  }

  selectPresupuestoDetalle(rowIndex: number, presupuestoDetalleId: number, event: any) {
    // console.log(rowIndex, presupuestoDetalleId, event, this.itemPresupuesto?.PresupuestoDetalle);
    if (rowIndex >= 0 && this.itemPresupuesto?.PresupuestoDetalle != null) {
      var controlName = event.target?.name ?? event.source?.ngControl?.name ?? event.source?.name ?? event.source?.id;
      var controlValue = event.target?.value ?? event.value ?? event.checked ?? event.option?.value;

      if (controlName == "Seleccionado")
        this.itemPresupuesto.PresupuestoDetalle[rowIndex].Seleccionado = controlValue;
    }
  }

  getErrorProveedor() {
    return this.formGroup.get('Proveedor')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorFormaPago() {
    return this.formGroup.get('FormaPagoId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorAlicuotaIva() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorTipoCompra() {
    return this.formGroup.get('TipoCompra')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMoneda() {
    return this.formGroup.get('MonedaId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMonto() {
    return this.formGroup.get('Monto')?.hasError('required') ? 'El campo es obligatorio' :'';
  }
}
